export const ENV_CONFIG = {
  dev: {
    global: 'https://api-dev.chirpee.co',
    regional: {
      us: 'https://us.api-dev.chirpee.co',
      eu: 'https://eu.api-dev.chirpee.co',
    },
  },
  prod: {
    global: 'https://api.chirpee.co',
    regional: {
      us: 'https://us.api.chirpee.co',
      eu: 'https://eu.api.chirpee.co',
    },
  },
} as const;
